import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import EfakturaSharingState from '../form/state';
import useFormContext from '../form/useFormContext';
import routes from '../routes';

type RequiredState = keyof EfakturaSharingState;

const useCanIBeHere = (requiredStates: RequiredState[], backUrl: string = routes.home) => {
    const {
        form: { state },
    } = useFormContext();
    const navigate = useNavigate();
    useEffect(() => {
        if (
            requiredStates.includes('selected') &&
            requiredStates.includes('amountSelected') &&
            state.amountSelected === 'some' &&
            !state.selected
        ) {
            navigate(backUrl);
            return;
        }
        if (!requiredStates.some((s) => state[s])) {
            navigate(backUrl);
        }
    }, [state, requiredStates, backUrl, navigate]);
};

export default useCanIBeHere;
